<template>
  <el-dialog
      :close-on-click-modal="false"
      :title="'司机油/气耗费用审核'"
      :lock-scroll="true"
      :visible.sync="dialogFormVisible"
      width="500px"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form @sub="sub" :noSubBtn="true" ref="customForm" :formData="formData" labelWidth="150px">
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="customFormPost('fail')"
                 :loading="failLoading || getDetailLoading"
      >审核不通过</el-button>
      <el-button
          type="primary"
          @click="customFormPost('pass')"
          :loading="subLoading || getDetailLoading"
      >审核通过</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  auditGasConsumption,
  auditOilConsumption,
} from 'api/operate';
import {floatSub} from '@qx/utils';
export default {
  data () {
    return {
      detailRes: {},
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      failLoading: false, // 审核不通过提交loading
      originData: {},
      formData: {
        acctNoOptions: [], // 账户名称
        form: [
          // 油耗start
          {
            label: '公里数',
            value: 'kilometre',
            type: 'show',
            unit: 'KM',
            hide: true,
          },
          {
            label: '每公里实际消耗',
            value: 'actualOilConsumption',
            type: 'show',
            unit: '升',
            hide: true,
          },
          {
            label: '每公里规定标准',
            value: 'standardOilConsumption',
            type: 'show',
            unit: '升',
            hide: true,
          },
          {
            label: '规定燃油量',
            value: 'standardRise',
            type: 'show',
            unit: 'L',
            hide: true,
          },
          {
            label: '实际加油升数',
            value: 'oilRise',
            type: 'show',
            unit: 'L',
            hide: true,
          },
          {
            label: '结余数量',
            value: 'surplusRise',
            type: 'show',
            unit: 'L',
            hide: true,
          },
          {
            label: '本趟油补',
            value: 'oilSubsidy',
            type: 'show',
            unit: '元',
            hide: true,
          },
          {
            label: '主驾油补',
            value: 'mainDriverSubsidy',
            type: 'show',
            unit: '元',
            hide: true,
          },
          {
            label: '主驾油补比例',
            value: 'oilSubsidyScaleMain',
            type: 'show',
            unit: '%',
            hide: true,
          },
          {
            label: '副驾油补',
            value: 'coDriverSubsidy',
            type: 'show',
            unit: '元',
            hide: true,
          },
          {
            label: '副驾油补比例',
            value: 'coOilSubsidyScaleMain',
            type: 'show',
            unit: '%',
            hide: true,
          },
          {
            label: '起始公里数',
            value: 'startingKilometerList',
            type: 'img',
            accept: 'image/*',
            previewAsImage: true,
            attr: {
              limit: 1,
            },
            default: [],
            disabled: true,
            hide: true,
          },
          {
            label: '终点公里数',
            value: 'endKilometerList',
            type: 'img',
            accept: 'image/*',
            previewAsImage: true,
            attr: {
              limit: 1,
            },
            default: [],
            disabled: true,
            hide: true,
          },
          {
            label: '加油升数',
            value: 'oilRiseImgList',
            type: 'img',
            accept: 'image/*',
            previewAsImage: true,
            default: [],
            disabled: true,
            hide: true,
          },
          // 油耗end
          // 气耗start
          {
            label: '公里数',
            value: 'gasKilometre',
            type: 'show',
            unit: 'KM',
            hide: true,
          },
          {
            label: '每公里规定标准',
            value: 'standardConsPerKilo',
            type: 'show',
            unit: 'KG',
            hide: true,
          },
          {
            label: '每公里实际消耗',
            value: 'actualConsPerKilo',
            type: 'show',
            unit: 'KG',
            hide: true,
          },
          {
            label: '规定燃气量',
            value: 'standardGasInjectionVolume',
            type: 'show',
            unit: 'KG',
            hide: true,
          },
          {
            label: '实际加气量',
            value: 'actualGasInjectionVolume',
            type: 'show',
            unit: 'KG',
            hide: true,
          },
          {
            label: '结余气量',
            value: 'surplusGasVolume',
            type: 'show',
            unit: 'KG',
            hide: true,
          },
          {
            label: '本趟气补',
            value: 'gasSubsidy',
            type: 'show',
            unit: '元',
            hide: true,
          },
          {
            label: '主驾气补',
            value: 'mainDriverGasSubsidy',
            type: 'show',
            unit: '元',
            hide: true,
          },
          {
            label: '主驾气补比例',
            value: 'gasSubsidyScaleMain',
            type: 'show',
            unit: '%',
            hide: true,
          },
          {
            label: '副驾气补',
            value: 'coDriverGasSubsidy',
            type: 'show',
            unit: '元',
            hide: true,
          },
          {
            label: '副驾气补比例',
            value: 'coGasSubsidyScaleMain',
            type: 'show',
            unit: '%',
            hide: true,
          },
          {
            label: '起始公里数',
            value: 'startingKilometerImgList',
            type: 'img',
            accept: 'image/*',
            previewAsImage: true,
            attr: {
              limit: 1,
            },
            default: [],
            disabled: true,
            hide: true,
          },
          {
            label: '终点公里数',
            value: 'endKilometerImgList',
            type: 'img',
            accept: 'image/*',
            previewAsImage: true,
            attr: {
              limit: 1,
            },
            default: [],
            disabled: true,
            hide: true,
          },
          {
            label: '加气数量',
            value: 'gasFillingQuantityImgList',
            type: 'img',
            accept: 'image/*',
            previewAsImage: true,
            default: [],
            disabled: true,
            hide: true,
          },
          // 气耗end
          {
            label: '审核意见',
            value: 'auditRemarks',
            type: 'input',
            // hide:true
          },
        ],
        rules: {
          auditRemarks: [
            { required: false, message: '请输入审核意见', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    show (item, detailRes) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(() => {
        this.$refs.customForm && this.$refs.customForm.reset();
        this.originData = item;
        this.detailRes = detailRes;
        this.setBaseForm();
        this.setDefaultData();
      });
    },
    setBaseForm () {
      let oilForm = ['kilometre', 'actualOilConsumption', 'standardOilConsumption', 'standardRise', 'oilRise', 'surplusRise', 'oilSubsidy', 'mainDriverSubsidy', 'oilSubsidyScaleMain', 'coDriverSubsidy', 'coOilSubsidyScaleMain', 'startingKilometerList', 'endKilometerList', 'oilRiseImgList'];
      let gasForm = ['gasKilometre', 'actualConsPerKilo', 'actualGasInjectionVolume', 'startingKilometerImgList', 'endKilometerImgList', 'gasFillingQuantityImgList', 'standardConsPerKilo', 'standardGasInjectionVolume', 'surplusGasVolume', 'gasSubsidy', 'mainDriverGasSubsidy', 'gasSubsidyScaleMain', 'coDriverGasSubsidy', 'coGasSubsidyScaleMain'];
      this.setFormAttrVal({
        form: this.formData,
        attr: 'hide',
        value: this.detailRes.energyType === 'A' || this.detailRes.energyType === 'B',
        names: [...gasForm],
      });
      this.setFormAttrVal({
        form: this.formData,
        attr: 'hide',
        value: this.detailRes.energyType === 'E',
        names: [...oilForm],
      });
    },
    async setDefaultData () {
      this.$refs.customForm.setVal('kilometre', this.originData.kilometreDouble);
      this.$refs.customForm.setVal('actualOilConsumption', this.originData.actualOilConsumptionDouble);
      this.$refs.customForm.setVal('standardOilConsumption', this.originData.standardOilConsumptionDouble);
      this.$refs.customForm.setVal('standardRise', this.originData.standardRiseDouble);
      this.$refs.customForm.setVal('oilRise', this.originData.oilRiseDouble);
      this.$refs.customForm.setVal('surplusRise', this.originData.surplusRiseDouble);
      this.$refs.customForm.setVal('oilSubsidy', this.originData.oilSubsidyDouble);
      this.$refs.customForm.setVal('mainDriverSubsidy', this.originData.mainDriverSubsidyDouble);
      this.$refs.customForm.setVal('coDriverSubsidy', this.originData.coDriverSubsidyDouble);
      this.$refs.customForm.setVal('oilSubsidyScaleMain', this.originData.oilSubsidyScaleMainStr);
      this.$refs.customForm.setVal('coOilSubsidyScaleMain', this.originData.coOilSubsidyScaleMainStr);

      this.$refs.customForm.setVal('gasKilometre', this.originData.kilometreDouble);
      this.$refs.customForm.setVal('actualConsPerKilo', this.originData.actualConsPerKiloDouble === null ? '--' : this.originData.actualConsPerKiloDouble);
      this.$refs.customForm.setVal('actualGasInjectionVolume', this.originData.actualGasInjectionVolumeDouble);
      this.$refs.customForm.setVal('standardConsPerKilo', this.originData.standardConsPerKiloDouble === null ? '--' : this.originData.standardConsPerKiloDouble);
      this.$refs.customForm.setVal('standardGasInjectionVolume', this.originData.standardGasInjectionVolumeDouble === null ? '--' : this.originData.standardGasInjectionVolumeDouble);
      this.$refs.customForm.setVal('surplusGasVolume', this.originData.surplusGasVolumeDouble === null ? '--' : this.originData.surplusGasVolumeDouble);
      this.$refs.customForm.setVal('gasSubsidy', this.originData.gasSubsidyDouble);
      this.$refs.customForm.setVal('mainDriverGasSubsidy', this.originData.mainDriverGasSubsidyDouble);
      this.$refs.customForm.setVal('gasSubsidyScaleMain', this.originData.gasSubsidyScaleMainDouble);
      this.$refs.customForm.setVal('coDriverGasSubsidy', this.originData.coDriverGasSubsidyDouble);
      this.$refs.customForm.setVal('coGasSubsidyScaleMain', this.originData.gasSubsidyDouble !== 0 ? floatSub(100, this.originData.gasSubsidyScaleMainDouble) : 0);
      this.handlePicture('oilRiseImgList', this.originData.oilRiseImg, this.originData.oilRiseImgUrl);
      this.handlePicture('startingKilometerList', this.originData.startingKilometer, this.originData.startingKilometerUrl);
      this.handlePicture('endKilometerList', this.originData.endKilometer, this.originData.endKilometerUrl);
      this.handlePicture('startingKilometerImgList', this.originData.startingKilometerImg, this.originData.startingKilometerImgUrl);
      this.handlePicture('endKilometerImgList', this.originData.endKilometerImg, this.originData.endKilometerImgUrl);
      this.handlePicture('gasFillingQuantityImgList', this.originData.gasFillingQuantityImg, this.originData.gasFillingQuantityImgUrl);
    },
    // 统一处理图片 fieldName为表单名称，idField为图片id数据，urlField为图片url数据
    handlePicture (fieldName, idField, urlField) {
      if (idField) {
        let dataList = idField.split(',');
        let urlList = urlField.split(',');
        let files = dataList.map((flowId, index) => ({
          id: flowId,
          url: urlList[index],
        }));
        this.$refs.customForm.setVal(fieldName, files);
      }
    },
    customFormPost (type) {
      if (type === 'fail') {
        this.formData.rules.auditRemarks[0].required = true;
        this.$refs.customForm.sub();
        // }
      } else {
        this.formData.rules.auditRemarks[0].required = false;
        this.subLoading = true;
        this.$refs.customForm.sub();
      }
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      let state = this.formData.rules.auditRemarks[0].required ? 1 : 0;
      let formData = null;
      if (form) {
        formData = {
          id: this.originData.id,
          orderId: this.originData.orderId,
          auditStatus: state, // 审核通过传0 不通过传1
          auditRemarks: this.$refs.customForm.getVal('auditRemarks') || '',
        };
      }
      let res;
      if (this.detailRes.energyType === 'A' || this.detailRes.energyType === 'B') {
        res = await auditOilConsumption(formData);
      } else if (this.detailRes.energyType === 'E') {
        res = await auditGasConsumption(formData);
      }
      this.failLoading = false;
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '提交成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style>
</style>
